module.exports = __webpack_public_path__ + "static/img/trading-2.cb5bb71.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/trading-2.jpg
// module id = ev6p
// module chunks = 1